<template>
  <div>
    <vs-dropdown vs-trigger-click>
      <vs-button
        class="mr-2 mt-1"
        style="border-radius: 20px"
        text-color="#111111"
        color="rgba(9, 30, 66, 0.04)"
        type="filled"
        icon="rate_review"
        id="show-btn"
        >Bulk Actions
      </vs-button>
      <vs-dropdown-menu style="width: 250px">
        <vs-dropdown-item @click="BulkDelete()"> Bulk Delete </vs-dropdown-item>
        <vs-dropdown-item @click="BulkUpadate()">
          Bulk Upadate
        </vs-dropdown-item>
        <vs-dropdown-item @click="BulkAsset()">
          Bulk Set Part/Asset Assciations
        </vs-dropdown-item>
        <vs-dropdown-item @click="BulkVendor()">
          Bulk Set Part/Vendor Assciations
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>

    <!-- Modal Delete -->
    <b-modal id="BulkDelete" centered size="xl">
      <template #modal-title>
        <h3>Bulk Delete Parts</h3>
      </template>
      <template>
        <p>Please choose which parts you would like to delete.</p>
        <br />
        <p><b style="color: red">This action can not be undone</b></p>
        <vs-divider></vs-divider>
        <vs-row>
          <vs-spacer></vs-spacer>
          <vs-input icon="search" placeholder="Search" v-model="value1" />
          <br />
        </vs-row>
        <vs-row class="mt-1">
          <vs-spacer></vs-spacer>
          <a>Deselect All</a> &nbsp;&nbsp;|&nbsp;&nbsp;
          <a class="mr-2">Select All</a>
        </vs-row>
        <br />
        <vs-card>
          <vs-row class="mt-3">
            <p>
              <vs-icon icon="settings" size="20px" class="mb-1 mr-2"></vs-icon
              >Welding wire - 0001 - Qty: 8 available
            </p>
            &nbsp;&nbsp;&nbsp; - &nbsp;&nbsp;&nbsp;
            <p>
              <vs-icon icon="home" size="20px" class="mb-1 mr-2"></vs-icon>
              Factory
            </p>
            <vs-spacer></vs-spacer>
            <vs-icon icon="help" class="mt-1" size="15px"></vs-icon>
          </vs-row>
        </vs-card>
        <p>
          If the part is not here please have a manager visit Parts Management
          to add a new part
        </p>
      </template>
      <template #modal-footer>
        <vs-row>
          <vs-button
            type="filled"
            style="border-radius: 20px; width: 15%"
            icon="add"
            variant="light"
            @click="$bvModal.hide('BulkDelete')"
            >Create Part</vs-button
          >
          <vs-spacer />
          <b-button
            id="btncancel"
            variant="light"
            style="border-radius: 20px; width: 10%"
          >
            Delete
          </b-button>
          <vs-button
            class="ml-2"
            type="filled"
            style="border-radius: 20px; width: 10%"
            @click="$bvModal.hide('BulkDelete')"
            >Close</vs-button
          >
        </vs-row>
      </template>
    </b-modal>

    <!-- Modal Update -->
    <b-modal id="BulkUpadate" centered hide-footer size="xl"
      ><template #modal-title>
        <h3>Bulk update your Parts from Factory</h3>
      </template>
      <br />
      <template>
        <div class="ml-2">
          <vs-col>
            <b>To bulk update Parts please follow the following steps:</b>
            <br />
            <br />
            <p @click="myFunction()">
              1) Download your current
              <a href="path_to_file" download="proposed_file_name"
                ><b>List of Parts</b></a
              >
            </p>

            <p>2) Edit the excel sheet with the changes you wish to make.</p>
            <p>3) Save and upload the file.</p>
            <br />
            <vs-checkbox
              color="success"
              v-model="checkBox2"
              style="right: 205px"
            >
              Only associate parts to assets and vendors at this
              location</vs-checkbox
            >

            <br />
            <br />
            <vs-button
              color="#32C040"
              style="border-radius: 20px"
              class="text-none mr-2"
              round
              depressed
              :loading="isSelecting"
              @click="onButtonClick"
              >Upload CSV
            </vs-button>
          </vs-col>
          <template>
            <vs-row class="ml-3 mt-5" vs-w="12">
              <vs-spacer />
              <b-button
                id="btncancel"
                variant="light"
                style="border-radius: 20px; width: 10%"
                @click="$bvModal.hide('BulkUpadate')"
              >
                Exit
              </b-button>
              <vs-button
                class="ml-2 mr-4"
                type="filled"
                style="border-radius: 20px"
                color="success"
                >Confirm</vs-button
              >
            </vs-row>
          </template>
        </div>
      </template>
    </b-modal>

    <!--modal set asset-->
    <b-modal id="BulkAsset" centered size="xl">
      <template #modal-title>
        <h3>Bulk Set Part/Asset Associations</h3>
      </template>
      <template>
        <p>Please set which Parts you would like to associate Assets to.</p>
        <br />

        <vs-divider></vs-divider>
        <vs-row>
          <vs-spacer></vs-spacer>
          <vs-input icon="search" placeholder="Search" v-model="value1" />
          <br />
        </vs-row>
        <vs-row class="mt-1">
          <vs-spacer></vs-spacer>
          <a>Deselect All</a> &nbsp;&nbsp;|&nbsp;&nbsp;
          <a class="mr-2">Select All</a>
        </vs-row>
        <br />
        <vs-card>
          <vs-row class="mt-3">
            <p>
              <vs-icon icon="settings" size="20px" class="mb-1 mr-2"></vs-icon
              >Welding wire - 0001 - Qty: 8 available
            </p>
            &nbsp;&nbsp;&nbsp; - &nbsp;&nbsp;&nbsp;
            <p>
              <vs-icon icon="home" size="20px" class="mb-1 mr-2"></vs-icon>
              Factory
            </p>
            <vs-spacer></vs-spacer>
            <vs-icon icon="help" class="mt-1" size="15px"></vs-icon>
          </vs-row>
        </vs-card>
        <p>
          If the part is not here please have a manager visit Parts Management
          to add a new part
        </p>
      </template>
      <template #modal-footer>
        <vs-row>
          <vs-button
            type="filled"
            style="border-radius: 20px; width: 15%"
            icon="add"
            variant="light"
            >Create Part</vs-button
          >
          <vs-spacer />
          <b-button
            id="btncancel"
            variant="light"
            style="border-radius: 20px; width: 10%"
          >
            Delete
          </b-button>
          <vs-button
            class="ml-2"
            type="filled"
            style="border-radius: 20px; width: 10%"
            @click="$bvModal.hide('BulkAsset')"
            >Close</vs-button
          >
        </vs-row>
      </template>
    </b-modal>

    <!--Modal set vendor-->
    <b-modal id="BulkVendor" centered size="xl">
      <template #modal-title>
        <h3>Bulk Set Part/Vendor Associations</h3>
      </template>
      <template>
        <p>Please select which Parts you would like to associate Vendors to</p>
        <br />

        <vs-divider></vs-divider>
        <vs-row>
          <vs-spacer></vs-spacer>
          <vs-input icon="search" placeholder="Search" v-model="value1" />
          <br />
        </vs-row>
        <vs-row class="mt-1">
          <vs-spacer></vs-spacer>
          <a>Deselect All</a> &nbsp;&nbsp;|&nbsp;&nbsp;
          <a class="mr-2">Select All</a>
        </vs-row>
        <br />
        <vs-card>
          <vs-row class="mt-3">
            <p>
              <vs-icon icon="settings" size="20px" class="mb-1 mr-2"></vs-icon
              >Welding wire - 0001 - Qty: 8 available
            </p>
            &nbsp;&nbsp;&nbsp; - &nbsp;&nbsp;&nbsp;
            <p>
              <vs-icon icon="home" size="20px" class="mb-1 mr-2"></vs-icon>
              Factory
            </p>
            <vs-spacer></vs-spacer>
            <vs-icon icon="help" class="mt-1" size="15px"></vs-icon>
          </vs-row>
        </vs-card>
        <p>
          If the part is not here please have a manager visit Parts Management
          to add a new part
        </p>
      </template>
      <template #modal-footer>
        <vs-row>
          <vs-button
            type="filled"
            style="border-radius: 20px; width: 15%"
            icon="add"
            variant="light"
            >Create Part</vs-button
          >
          <vs-spacer />
          <b-button
            id="btncancel"
            variant="light"
            style="border-radius: 20px; width: 10%"
          >
            Delete
          </b-button>
          <vs-button
            class="ml-2"
            type="filled"
            style="border-radius: 20px; width: 10%"
            @click="$bvModal.hide('BulkVendor')"
            >Close</vs-button
          >
        </vs-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
// import t from "../t.vue";
export default {
  data() {
    return {
      value1: "",
    };
  },
  // components: { t },
  methods: {
    BulkDelete() {
      this.$bvModal.show("BulkDelete");
    },
    BulkUpadate() {
      this.$bvModal.show("BulkUpadate");
    },
    BulkAsset() {
      this.$bvModal.show("BulkAsset");
    },
    BulkVendor() {
      this.$bvModal.show("BulkVendor");
    },
  },
};
</script>

<style>
</style>